'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _underscore = require('underscore');

var _UIButton = require('UIComponents/button/UIButton');

var _UIButton2 = _interopRequireDefault(_UIButton);

var _tracker = require('ui-addon-upgrades/_core/common/eventTracking/tracker');

var tracker = _interopRequireWildcard(_tracker);

var _upgradeDataPropsInterface = require('ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface');

var _ProductActivationWrapper = require('ui-addon-upgrades/_core/common/components/ProductActivationWrapper');

var _ProductActivationWrapper2 = _interopRequireDefault(_ProductActivationWrapper);

var _activateProduct = require('ui-addon-upgrades/_core/productActivation/activateProduct');

var _AdminOnlyWrapper = require('ui-addon-upgrades/_core/common/components/AdminOnlyWrapper');

var _AdminOnlyWrapper2 = _interopRequireDefault(_AdminOnlyWrapper);

var _AdminTypes = require('ui-addon-upgrades/_core/common/constants/AdminTypes');

var _AdminModalTypes = require('ui-addon-upgrades/_core/common/constants/AdminModalTypes');

var _productProperties = require('ui-addon-upgrades/_core/common/constants/productProperties');

var _productProperties2 = _interopRequireDefault(_productProperties);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProductActivationButton = function (_Component) {
  _inherits(ProductActivationButton, _Component);

  function ProductActivationButton() {
    _classCallCheck(this, ProductActivationButton);

    var _this = _possibleConstructorReturn(this, (ProductActivationButton.__proto__ || Object.getPrototypeOf(ProductActivationButton)).call(this));

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(ProductActivationButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var upgradeData = this.props.upgradeData;


      tracker.track('productActivationButtonInteraction', _extends({
        action: 'viewed'
      }, upgradeData));
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      var _props = this.props,
          upgradeData = _props.upgradeData,
          onSuccess = _props.onSuccess;


      tracker.track('productActivationButtonInteraction', _extends({
        action: 'clicked'
      }, upgradeData));
      (0, _activateProduct.activateProduct)(upgradeData, onSuccess);
    }
  }, {
    key: 'render',
    value: function render() {
      var upgradeProduct = this.props.upgradeData.upgradeProduct;

      var propsToPass = (0, _underscore.omit)(this.props, ['onClick', 'upgradeData', 'onSuccess', 'allowModal']);

      return _react2.default.createElement(
        _AdminOnlyWrapper2.default,
        {
          adminType: _AdminTypes.TEAM,
          modalType: _AdminModalTypes.REQUEST_PRODUCT,
          merchandiseId: _productProperties2.default[upgradeProduct].merchandiseId
        },
        _react2.default.createElement(
          _UIButton2.default,
          _extends({}, propsToPass, {
            'data-reagan-primary-cta': true,
            onClick: this.handleClick
          }),
          _react2.default.createElement(_FormattedMessage2.default, {
            message: 'upgrades.productActivationButton.' + upgradeProduct
          })
        )
      );
    }
  }]);

  return ProductActivationButton;
}(_react.Component);

ProductActivationButton.defaultProps = {
  use: 'primary'
};

ProductActivationButton.propTypes = _extends({}, _upgradeDataPropsInterface.upgradeDataPropsInterface, {
  onSuccess: _react.PropTypes.func
});

exports.default = (0, _ProductActivationWrapper2.default)(ProductActivationButton);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/productActivation/ProductActivationButton.js
// module id = 647
// module chunks = 3 4